import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageSquare = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" className="sociavore-icon" viewBox="0 0 24 24" width="1em" height="1em" {...props}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>;
export default SvgMessageSquare;